import { AnnotatorTool, Type } from "./annotator-tool";

// @ToolRegister
export class Shape implements AnnotatorTool{
    code = Type.shape;
    get quickAction(){
        return {
            html : `<div class="flex-basis">
            <button id="ann-shape" class="btn btn-clear comment" tabindex="0">
                <i class="fa fa-comment" aria-hidden="true"></i>
            </button>
            </div>`,
            id : 'ann-shape'
        }
    }
    cursor = 'crosshair';
    className = 'annotator-shape';
    /**only in shape attachcomment means if we cant create shapes without add a comment */
    attachComment = false;
    showTrash = true;
    tooltip = 'design.tool.comment';

    constructor(){}
}